// extracted by mini-css-extract-plugin
export default {"project-template-tasks":"styles_project-template-tasks__G+2QF"};